export const OBJECTSTORE_ROQ_PERIOD = "RoqPeriod";
export const OBJECTSTORE_ROQ_PERIOD_TOTALS = "RoqPeriodTotals";